import { EmployeeLoginPage } from '../../../../components/EmployeeLoginPage/EmployeeLoginPage.js';
import { SiteContext } from '../../SiteContext.js';
import { initiateElisaIdV2Login } from '../../../common/util/elisaIdLogin.js';
import { useAuth } from '../../AuthProvider';
import { useContext } from 'react';

export const EmployeeLoginPath = () => {
  const { siteLanguage } = useContext(SiteContext);
  const { prepareElisaIdLogin, elisaIdV3Enabled } = useAuth();
  return (
    <div id="elisaid-login-form-parent" className="of-employee__employee-portal-home">
      <EmployeeLoginPage
        initiateLogin={() =>
          elisaIdV3Enabled ? prepareElisaIdLogin() : initiateElisaIdV2Login(siteLanguage.substring(0, 2))
        }
      />
    </div>
  );
};
